export default "__VITE_ASSET__acf56800__"